import type { ToastType } from './toast-hooks';

export const TOAST_EVENT = 'app-toast';
export const CONFIRM_EVENT = 'app-confirm';

export interface ToastEventDetail {
    message: string;
    type?: ToastType;
    duration?: number;
}

export interface ConfirmEventDetail {
    message: string;
    confirmText: string;
    cancelText: string;
    resolve: (value: boolean) => void;
}

export const isToastEventDetail = (value: unknown): value is ToastEventDetail => {
    if (typeof value !== 'object' || value === null) return false;
    const detail = value as Record<string, unknown>;
    const type = detail.type;
    return (
        typeof detail.message === 'string' &&
        (type === undefined ||
            type === 'success' ||
            type === 'error' ||
            type === 'warning' ||
            type === 'info' ||
            type === 'progress') &&
        (detail.duration === undefined || typeof detail.duration === 'number')
    );
};

export const isConfirmEventDetail = (value: unknown): value is ConfirmEventDetail => {
    if (typeof value !== 'object' || value === null) return false;
    const detail = value as Record<string, unknown>;
    return (
        typeof detail.message === 'string' &&
        typeof detail.confirmText === 'string' &&
        typeof detail.cancelText === 'string' &&
        typeof detail.resolve === 'function'
    );
};
